import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import api from '../../services/api'
import Loader from '../Utils/Loader'
import { buildPersonOptions, personOptionMatches } from '../../utils/personSelect'
import '../../css/addCompany.css'

const AddCompany = () => {
  const navigate = useNavigate()
  const [peopleOptions, setPeopleOptions] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    people: [],
    imageBase64: '',
  })
  const [preview, setPreview] = useState(null)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    api.get('/people')
      .then(res => {
        setPeopleOptions(buildPersonOptions(res.data))
      })
      .catch(err => console.error('Errore nel recupero persone:', err))
      .finally(() => setIsLoading(false))
  }, [])

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSelect = selected => {
    const values = Array.isArray(selected) ? selected.map(option => option.value) : []
    setFormData(prev => ({ ...prev, people: values }))
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (!file) {
      setPreview(null)
      setFormData(prev => ({ ...prev, imageBase64: '' }))
      return
    }
    const reader = new FileReader()
    reader.onloadend = () => {
      setPreview(reader.result)
      setFormData(prev => ({ ...prev, imageBase64: reader.result }))
    }
    reader.readAsDataURL(file)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    setSuccess('')
    setIsSubmitting(true)

    try {
      await api.post('/companies', formData, {
        headers: { 'Content-Type': 'application/json' },
      })
      setSuccess('Azienda creata con successo!')
      setFormData({
        name: '',
        description: '',
        people: [],
        imageBase64: '',
      })
      setPreview(null)
    } catch (err) {
      console.error('Errore creazione azienda:', err)
      const msg = err?.response?.data?.error || 'Errore nella creazione dell\'azienda'
      setError(msg)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="addcompany-wrapper">
      <div className="addcompany-card">
        <h2>Aggiungi Azienda</h2>

        {isLoading ? (
          <div className="addcompany-loader">
            <Loader />
          </div>
        ) : (
          <>
            {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>}

            <form onSubmit={handleSubmit} className="addcompany-form">
              <label>
                Nome:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Nome azienda"
                />
              </label>

              <label>
                Descrizione:
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows={5}
                  placeholder="Descrizione dell'azienda"
                />
              </label>

              <label>
                Collega persone:
                <Select
                  isMulti
                  options={peopleOptions}
                  filterOption={personOptionMatches}
                  value={peopleOptions.filter(option => formData.people.includes(option.value))}
                  onChange={handleSelect}
                  classNamePrefix="company-select"
                  placeholder="Seleziona persone da associare"
                />
              </label>

              <label>
                Logo/Immagine:
                <input type="file" accept="image/*" onChange={handleFileChange} />
              </label>
              {preview && (
                <div className="company-preview">
                  <img src={preview} alt="Anteprima azienda" />
                </div>
              )}

              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Salvataggio...' : 'Crea Azienda'}
              </button>
            </form>

            {success && (
              <button className="redirect-btn" onClick={() => navigate('/dashboard')}>
                Vai alla Dashboard
              </button>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default AddCompany
